import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronUpCondensedLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		transform: "scale(1.5)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M13.1017 9.5814C13.2387 9.34165 13.1552 9.0361 12.9155 8.89911L8.24884 6.23244C8.09516 6.14466 7.90643 6.14466 7.75275 6.23244L3.08608 8.89911C2.84634 9.0361 2.76293 9.34165 2.89988 9.5814C3.03687 9.82114 3.34243 9.90455 3.58217 9.7676L8.00079 7.24286L12.4194 9.7676C12.6592 9.90455 12.9647 9.82114 13.1017 9.5814Z",
			fill: "currentColor"
		})
	})
});
export default SvgChevronUpCondensedLine;
